import { ReactNode, VFC } from 'react'
import { Footer } from 'src/components/Footer'
import { GuestFooter } from 'src/components/Footer/GuestFooter'
import {
  GuestHeader,
  MemberHeader,
  MemberHeaderProps,
} from 'src/components/Header'
import { BreadCrumbProps } from 'src/components/BreadCrumb'
import styled, { css } from 'styled-components'
import { HEADER_HEIGHT } from '../Header/WideHeader/HeaderWrapper'
import { BANNER_HEIGHT, BANNER_MARGIN } from '../TopPageBanner'

type PageWrapperProps = {
  children: ReactNode
  className?: string
  shouldDisplayBanner?: boolean | null
  backgroundColor?: string
}
type MemberPageWrapperProps = PageWrapperProps & MemberHeaderProps

export const MemberPageWrapper: VFC<MemberPageWrapperProps> = ({
  children,
  className,
  backgroundColor,
  ...headerProps
}) => (
  <>
    <MemberHeader {...headerProps} />
    <Main
      className={className}
      currentPath={headerProps.currentPath}
      shouldDisplayBanner={headerProps.shouldDisplayBanner}
      free={headerProps.user.plan.free}
      backgroundColor={backgroundColor}
    >
      {children}
    </Main>
    <Footer />
  </>
)

export const GuestPageWrapper: VFC<
  PageWrapperProps & Partial<BreadCrumbProps>
> = ({
  children,
  className,
  backgroundColor,
  currentPath,
  parentPaths,
  color,
}) => (
  <>
    <GuestHeader
      currentPath={currentPath}
      parentPaths={parentPaths}
      color={color}
    />
    <Main className={className} backgroundColor={backgroundColor}>
      {children}
    </Main>
    <GuestFooter />
  </>
)

export const PAGE_PADDING_HEIGHT = '100px'

const Main = styled.main<{
  currentPath?: string | null
  shouldDisplayBanner?: boolean | null
  free?: boolean
  backgroundColor?: string
}>`
  padding: calc(${PAGE_PADDING_HEIGHT} - ${HEADER_HEIGHT}) 0
    ${PAGE_PADDING_HEIGHT};
  margin: 0 auto;
  width: 100%;
  ${({ backgroundColor }) =>
    backgroundColor &&
    css`
      background-color: ${backgroundColor};
    `}

  ${({ shouldDisplayBanner, free }) =>
    shouldDisplayBanner &&
    css`
      padding-top: calc(
        ${HEADER_HEIGHT} + ${BANNER_HEIGHT} + ${BANNER_MARGIN} + 22px
      );

      @media screen and (max-width: 1024px) {
        padding-top: calc(
          ${HEADER_HEIGHT} + ${BANNER_HEIGHT} * ${free ? 2 : 1} + 22px
        );
      }
    `};

  ${({ currentPath }) =>
    !currentPath &&
    css`
      padding: 45px 0 100px;
      @media screen and (min-width: 540px) {
        padding: 100px 0;
      }
    `}
`
